/* Galerie & Kunsthaus Nottbohm — Kopfzeile
   Das Theme gibt bei der Menüart „beides“ mehrere Menü-Buttons aus.
   Hier wird der erste sichtbare gekennzeichnet, alle weiteren bekommen
   eine eigene Klasse und werden am Rechner ausgeblendet.
   Außerdem: Im Handy-Menü gibt das Theme das Hauptmenü zweimal aus
   (Burger-Menü und Hauptmenü sind dasselbe Menü) und hängt darunter das
   Fußzeilenmenü an. Doppelte Einträge werden hier entfernt, ebenso
   Zusatzlinks, die schon im Menü stehen, und „Suchen“ (Suche steht oben).
   Nicht Teil des Impression-Themes.
*/
(function () {
	"use strict";

	function kopf() {
		return document.querySelector(".header__container") || document.querySelector("header");
	}

	function burger() {
		var k = kopf();
		if (!k) return;

		// Kandidaten einsammeln: Elemente mit „burger“ im Klassennamen,
		// die eine Schaltfläche enthalten oder selbst eine sind.
		var roh = k.querySelectorAll('[class*="burger"]');
		var liste = [];
		Array.prototype.forEach.call(roh, function (el) {
			if (!el.querySelector("button") && el.tagName !== "BUTTON") return;
			// Verschachtelte Treffer überspringen: nur den äußersten nehmen
			for (var i = 0; i < liste.length; i++) {
				if (liste[i].contains(el)) return;
			}
			liste.push(el);
		});
		if (!liste.length) return;

		var behalten = null;
		liste.forEach(function (el) {
			var sichtbar = el.offsetParent !== null || el.getBoundingClientRect().width > 0;
			if (!behalten && sichtbar) behalten = el;
		});
		if (!behalten) behalten = liste[0];

		liste.forEach(function (el) {
			if (el === behalten) {
				el.classList.add("nb-burger");
				el.classList.remove("nb-burger-doppelt");
			} else {
				el.classList.remove("nb-burger");
				el.classList.add("nb-burger-doppelt");
			}
		});
	}

	function pfad(a) {
		var h = a.getAttribute("href") || "";
		try { h = new URL(h, window.location.origin).pathname; } catch (e) {}
		return h.replace(/\/+$/, "") || "/";
	}

	// Oberste Menüpunkte nur einmal: gleicher Text und gleiches Ziel
	function einmalig(liste) {
		var gesehen = {};
		Array.prototype.slice.call(liste.children).forEach(function (li) {
			var el = li.querySelector("a, button");
			if (!el) return;
			var schluessel = (el.textContent || "").trim().toLowerCase() + "|" + (el.tagName === "A" ? pfad(el) : "");
			if (gesehen[schluessel]) {
				li.parentNode.removeChild(li);
			} else {
				gesehen[schluessel] = true;
			}
		});
	}

	// Zusatzlinks entfernen, deren Ziel schon im Menü steht
	function zusatzlinks(menuLinks, zusatzListe, auchSuche) {
		if (!zusatzListe) return;
		var vorhanden = {};
		Array.prototype.forEach.call(menuLinks, function (a) { vorhanden[pfad(a)] = true; });
		if (auchSuche) vorhanden["/search"] = true;
		Array.prototype.slice.call(zusatzListe.querySelectorAll("a[href]")).forEach(function (a) {
			if (!vorhanden[pfad(a)]) return;
			var li = a.closest("li") || a;
			if (li.parentNode) li.parentNode.removeChild(li);
		});
	}

	function menues() {
		var mobil = document.querySelector(".header-mobile__menu-list:not(.header-mobile__menu-list--nested)");
		if (mobil) {
			einmalig(mobil);
			zusatzlinks(
				mobil.querySelectorAll("a[href]"),
				document.querySelector(".header-mobile__additional-link-list"),
				!!document.querySelector('.header-mobile [data-target="headerDrawerSearch"]')
			);
		}
		zusatzlinks(
			document.querySelectorAll(".header-burger-menu-content a[href]"),
			document.querySelector(".header-burger-menu-content__additional-link-list"),
			false
		);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", burger);
		document.addEventListener("DOMContentLoaded", menues);
	} else {
		burger();
		menues();
	}

	window.addEventListener("load", burger);

	var warte;
	window.addEventListener("resize", function () {
		window.clearTimeout(warte);
		warte = window.setTimeout(burger, 250);
	});
})();
